import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/satisfacao/:ticketJwt',
    name: 'FormularioSatisfacao',
    component: () => import('../views/FormularioSatisfacao.vue')
  },
  {
    path: '/portal',
    name: 'PortalBusca',
    component: () => import('../views/PortalBusca.vue')
  },
  {
    path: '/portal/:jwt',
    name: 'PortalBuscaJwt',
    component: () => import('../views/PortalBusca.vue')
  },
  {
    path: '/portal/ticket/:id',
    name: 'PortalTicket',
    component: () => import('../views/PortalTicket.vue')
  },
  {
    path: '/',
    name: 'FormularioPosVendas',
    component: () => import('../views/FormularioPosVendas.vue')
  }
]

const router = new VueRouter({
  routes
})

export default router
